import MenuIcon from "@mui/icons-material/Menu";
import { Button, Stack } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useProfile from "../../hooks/useProfile";
import logo from "../../Images/KYABRS.png";
import profile from "../../Images/profile.png";
import { handleDrawer } from "../../redux/Reducer/NavSidebarSlice";
import "../Navbar/navbar.scss";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Navbar = () => {
  const open = useSelector((state) => state.NavSidebar.open);
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    localStorage.clear();
    window.location = "/login";
  };

  const [userData] = useProfile();

  return (
    <AppBar
      style={{
        padding: ".2rem",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "#ffffff",
        color: "#2b3445",
        boxShadow: "#2b3445 0px 1px 7px 0px",
      }}
      position="fixed"
      open={open}
      // className="appbar"
    >
      <Toolbar>
        <IconButton
          aria-label="open drawer"
          onClick={() => {
            dispatch(handleDrawer());
          }}
          edge="start"
          sx={{ mr: 5 }}
        >
          <MenuIcon />
        </IconButton>

        <div
          style={{
            // color: "black",
            width: "100%",
            ...(open && { display: "none" }),
          }}
        >
          <img
            src={logo}
            style={{
              height: "40px",
              width: "150px",
              marginTop: "10px",
              marginRight: "15px",
            }}
            alt=""
          />
        </div>
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
          width="100%"
        >
          <div>
            <Button
              aria-controls={menuOpen ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={menuOpen ? "true" : undefined}
              onClick={handleClick}
              sx={{
                Color: "#188ff0",
                fontSize: "1.75rem",
              }}
            >
              <img
                style={{
                  height: "40px",
                  width: "auto",
                  borderRadius: "50%",
                }}
                src={userData.user_image || profile}
                alt=""
              />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              sx={{ padding: "10px !important" }}
              className="profile-menu"
            >
              <MenuItem>{userData.full_name}</MenuItem>

              <Link style={{ color: "black" }} to="/profile">
                <MenuItem>Profile</MenuItem>
              </Link>

              <Link style={{ color: "red" }}>
                <MenuItem onClick={logout}>Logout</MenuItem>
              </Link>
            </Menu>
          </div>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
